module.exports = __webpack_public_path__ + "img/senalando-izqus.dba59ed4.png";